export default "__VITE_ASSET__83c7a479__"